import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { getTopics, searchTopic, askQuestions } from "../thunk/IeqGptThunk";
import { ChatSourceTypeData } from "../../components/ieqGpt/InternalExternal";
export type ArticleType = {
    msg_date: string;
    author_name: string;
    title: string;
    title_link: string;
    image?: string;
}
export type ChatType = {
    id: string;
    question: string;
    responses: {
        source?: string;
        message: string;
        type?: string;
    }[];
}
export type ChatSourceType = {
    name: string;
    value: string;
    theme?: {
        primary: string;
    };
    subTitle: string;
    icon: string;
    iconWhite: string;
    LockMui: any
}
type IeqGptSlice = {
    topics: string[];
    articles: ArticleType[];
    chat: ChatType[];
    currentType: ChatSourceType
}
const initialState: IeqGptSlice = {
    topics: [],
    articles: [],
    chat: [],
    currentType: ChatSourceTypeData[0]
}
const ieqGptSlice = createSlice({
    name: "IeqGptSlice",
    initialState: initialState,
    reducers: {
        makeEntryInChat(state, action: PayloadAction<ChatType>) {
            return {
                ...state,
                chat: [...state.chat, action.payload]
            }
        },
        emptyArticles(state) {
            return {
                ...state,
                articles: []
            }
        },
        setChatSource(state, action: PayloadAction<ChatSourceType>) {
            return {
                ...state,
                currentType: action?.payload
            }
        }
    },
    extraReducers(builder) {
        builder.addCase(getTopics.fulfilled, (state, action) => {
            return {
                ...state,
                topics: action?.payload?.topics || []
            }
        })
        builder.addCase(getTopics.rejected, (state) => {
            return state;
        })
        builder.addCase(searchTopic.fulfilled, (state, action) => {
            return {
                ...state,
                articles: action?.payload?.results || []
            }
        })
        builder.addCase(searchTopic.rejected, (state) => {
            return state;
        })
        builder.addCase(askQuestions.fulfilled, (state, action) => {
            const chat = state.chat.map((value) => {
                if (value?.id === action?.payload?.id)
                    return { ...value, responses: [...value.responses, action?.payload] }
                else
                    return value;
            })
            return { ...state, chat };

        })
        builder.addCase(askQuestions.rejected, (state, action) => {
            const data = action?.payload as { id: string, message: string }
            const chat = state.chat.map((value) => {
                if (value?.id === data?.id)
                    return { ...value, responses: [...value.responses, { message: data?.message }] }
                else
                    return value;
            })
            return { ...state, chat };
        })
    },
});

export const { makeEntryInChat, emptyArticles, setChatSource } = ieqGptSlice.actions;
export default ieqGptSlice.reducer;